import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { PaMatrixService, Problem } from '../../services/pa-matrix.service';
import * as dayjs from 'dayjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-close-problem',
    templateUrl: './close-problem.component.html',
    styleUrls: ['./close-problem.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatFormField, MatInput, MatDialogActions, MatButton]
})
export class CloseProblemComponent implements OnInit {

  problem:Problem;
  closeFormGroup:UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<CloseProblemComponent>,
    private svcPAMatrix:PaMatrixService,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) { 
    this.problem = this.inData.problemData;

    if (!this.problem.ClosedDate || this.problem.ClosedDate == "") {
      this.problem.ClosedDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    }

    this.closeFormGroup = this.fb.group({
      ClosedDate: new UntypedFormControl({value: this.problem.ClosedDate, disabled: false}, Validators.required)
    });
  }

  ngOnInit(): void {
  }

  saveData():void {
    console.log("Close Problem");

    this.problem.Status = 0;

    this.svcPAMatrix.problemAddEdit(this.problem).subscribe(
      out => {
        console.log(out);
        this.dialogRef.close();
      }
    );
  }

  onNoClick():void {
    console.log("Close");
    this.dialogRef.close();
  }

}
